import { notification as antdNotification } from "antd";

// Configure static notification behavior with maxCount 2 and placement topRight
antdNotification.config({
    maxCount: 2,
    placement: "topRight",
});

/**
 * Global Notification Utility for Nearzon
 * This utility can be "bound" to the Ant Design App context for better reliability.
 */

let notificationApi = antdNotification;

// This function is used to bind the static utility to the App context
export const bindNotifyInstance = (instance) => {
    if (instance) {
        notificationApi = instance;
    }
};

const Notify = {
    success: (title, description = "") => {
        const msg = description ? title : "Success";
        const desc = description ? description : title;

        notificationApi.success({
            message: <span className="pcu-font-600 pcu-color-title pcu-font-14">{msg}</span>,
            description: <span className="pcu-font-12 pcu-color-secondary">{desc}</span>,
            placement: "topRight",
            duration: 2,
            className: "premium-notify success",
            style: {
                borderRadius: '16px',
                background: 'rgba(255, 255, 255, 0.85)',
                backdropFilter: 'blur(12px)',
                WebkitBackdropFilter: 'blur(12px)',
                border: '1px solid rgba(34, 197, 94, 0.2)',
                boxShadow: '0 8px 32px rgba(34, 197, 94, 0.1)',
                padding: '16px',
            },
        });
    },

    error: (msgOrErr, description = "") => {
        let finalTitle = "Error";
        let finalDesc = description;

        if (msgOrErr && typeof msgOrErr === "object") {
            const data = msgOrErr.response?.data;
            let extractedMsg = msgOrErr.message || data?.message;
            if (data?.errors && Array.isArray(data.errors) && data.errors.length > 0) {
                extractedMsg = data.errors[0].message || extractedMsg;
            } else if (data?.message) {
                extractedMsg = data.message;
            }
            if (extractedMsg) {
                if (description) {
                    finalTitle = description;
                    finalDesc = extractedMsg;
                } else {
                    finalDesc = extractedMsg;
                }
            }
        } else if (typeof msgOrErr === "string") {
            if (description) {
                finalTitle = msgOrErr;
                finalDesc = description;
            } else {
                finalDesc = msgOrErr;
            }
        }

        notificationApi.error({
            message: <span className="pcu-font-600 pcu-color-title pcu-font-14">{finalTitle}</span>,
            description: <span className="pcu-font-12 pcu-color-secondary">{finalDesc || "Something went wrong."}</span>,
            placement: "topRight",
            duration: 2.5,
            className: "premium-notify error",
            style: {
                borderRadius: '16px',
                background: 'rgba(255, 255, 255, 0.85)',
                backdropFilter: 'blur(12px)',
                WebkitBackdropFilter: 'blur(12px)',
                border: '1px solid rgba(239, 68, 68, 0.2)',
                boxShadow: '0 8px 32px rgba(239, 68, 68, 0.1)',
                padding: '16px',
            },
        });
    },

    info: (title, description = "") => {
        const msg = description ? title : "Information";
        const desc = description ? description : title;

        notificationApi.info({
            message: <span className="pcu-font-600 pcu-color-title pcu-font-14">{msg}</span>,
            description: <span className="pcu-font-12 pcu-color-secondary">{desc}</span>,
            placement: "topRight",
            duration: 2,
            className: "premium-notify info",
            style: {
                borderRadius: '16px',
                background: 'rgba(255, 255, 255, 0.85)',
                backdropFilter: 'blur(12px)',
                WebkitBackdropFilter: 'blur(12px)',
                border: '1px solid rgba(59, 130, 246, 0.2)',
                boxShadow: '0 8px 32px rgba(59, 130, 246, 0.1)',
                padding: '16px',
            },
        });
    },

    warning: (title, description = "") => {
        const msg = description ? title : "Warning";
        const desc = description ? description : title;

        notificationApi.warning({
            message: <span className="pcu-font-600 pcu-color-title pcu-font-14">{msg}</span>,
            description: <span className="pcu-font-12 pcu-color-secondary">{desc}</span>,
            placement: "topRight",
            duration: 2,
            className: "premium-notify warning",
            style: {
                borderRadius: '16px',
                background: 'rgba(255, 255, 255, 0.85)',
                backdropFilter: 'blur(12px)',
                WebkitBackdropFilter: 'blur(12px)',
                border: '1px solid rgba(245, 158, 11, 0.2)',
                boxShadow: '0 8px 32px rgba(245, 158, 11, 0.1)',
                padding: '16px',
            },
        });
    },
};

export default Notify;
